// extracted by mini-css-extract-plugin
export var required = "_h5-0";